<script setup lang="ts">
import {useStoreSelectedServiceChildren} from "~/composables/store/order/serviceForm";

const MAX_COUNT = 50

const props = defineProps({
  service: {
    type: Object,
    default: () => {
    }
  }
})
const emit = defineEmits(['selected'])
const selectedChildrenService = useStoreSelectedServiceChildren()

function handleSelectChildrenService(service: any) {
  if (selectedChildrenService.value[service.service_id]) {
    if (Object.keys(selectedChildrenService.value).length !== 0) {
      delete selectedChildrenService.value[service.service_id]
    }
  } else {
    selectedChildrenService.value[service.service_id] = {
      service_id: service.service_id,
      title: service.title,
      price: service.price,
      duration: service.duration,
      count: 1
    }
  }
  emit('selected')
}

function handleIncrement(service: any) {
  const entry = selectedChildrenService.value[service.service_id]
  if (entry.count < MAX_COUNT) {
    entry.count++
  }
}

function handleDecrement(service: any) {
  const entry = selectedChildrenService.value[service.service_id]
  if (entry.count > 1) {
    entry.count--
  } else {
    handleSelectChildrenService(service)
  }
}
</script>

<template>
  <div class="flex items-center justify-between gap-[10px] py-[10px]">
    <div class="flex flex-col gap-1 min-w-0 pr-[10px]">
      <p class="text-sm md:text-base font-semibold text-[#16211C] truncate">{{ service?.title }}</p>
      <p v-if="service?.price" class="text-xs md:text-sm text-[#8a938e]">+{{ formatPrice(service?.price) }} ₸</p>
      <p class="text-xs md:text-sm font-normal text-secondary-800">{{ service?.description }}</p>
    </div>

    <div v-if="selectedChildrenService[service.service_id]" class="flex items-center gap-[10px] flex-shrink-0 mb-auto">
      <button
          @click="handleDecrement(service)"
          class="w-[28px] h-[28px] md:w-[34px] md:h-[34px] rounded-lg text-[17px] md:text-base leading-none border-[1.5px] border-[#E8EAE8] bg-white text-[#16211C]"
      >
        −
      </button>
      <span class="text-sm md:text-base font-bold text-[#16211C] min-w-[12px] text-center">{{ selectedChildrenService[service.service_id].count }}</span>
      <button
          @click="handleIncrement(service)"
          class="w-[28px] h-[28px] md:w-[34px] md:h-[34px] rounded-lg text-[17px] md:text-base leading-none border-[1.5px] border-primary-green bg-primary-green text-white"
      >
        +
      </button>
    </div>

    <button
        v-else
        @click="handleSelectChildrenService(service)"
        class="w-[30px] h-[30px] md:w-[36px] md:h-[36px] rounded-[9px] border-[1.5px] border-primary-green bg-primary-green/10 text-primary-green text-xl md:text-base leading-none flex items-center justify-center flex-shrink-0 mb-auto"
    >
      +
    </button>
  </div>
</template>

<style scoped>

</style>
